import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';
import { IconsModule } from "../icons/icons.module";
import { LaunchTimeComponentModule } from "../launch-time/launch-time.component.module";
import { UpcomingLaunchCardComponentModule } from "../upcoming-launch-card/upcoming-launch-card.component.module";
import { UpcomingLaunchWidget } from "./upcoming-launch-widget.component";

@NgModule({
  imports: [
    // Common
    CommonModule,
    IconsModule,
    RouterModule,
    UpcomingLaunchCardComponentModule,
    LaunchTimeComponentModule
  ],
  declarations: [UpcomingLaunchWidget],
  exports: [UpcomingLaunchWidget],
})
export class UpcomingLaunchWidgetComponentModule { }
